export enum APP_STATUS {
  IDLE = 'idle',
  LOADING = 'loading',
  FAILED = 'failed',
  READY = 'ready'
}

export enum APP_ERROR {
  /**
   * When the Journey is not found or can't be determined due to missing
   * details (i.e. Id not provided).
   */
  JOURNEY_NOT_FOUND = 'journey-not-found',
  /**
   * The provided token has expired.
   * Currently used by Post Qualification journeys to control the TTL of associated links.
   */
  JOURNEY_TOKEN_EXPIRED = 'journey-token-expired',
  /**
   * Indicates the Journey has been previously submitted and is restricted to a single submission.
   */
  JOURNEY_NONCE = 'journey-nonce'
}

export enum APP_MODE {
  PREVIEW = 'preview',
  LIVE = 'live'
}
